module.exports = __webpack_public_path__ + "static/media/CaretDown.19774db1.svg";